import React from 'react';
import { Link } from "react-router-dom";

const purchasedItem = (props) => {
    return(
        <div className="purchased--item-row bg-grey custom-mt-15">
            <div className="row">
                <div className="col-xl-5 col-lg-6">
                    <div className="cart-col-one-outer">
                        <div className="cart-info-outer">
                            {props.cart.allday_deals ? <p className="cart-deal-infoo-text">{props.cart.allday_deals} x Per person deals</p>:null}
                            {props.cart.oneday_deals ? <p className="cart-deal-infoo-text">{props.cart.oneday_deals} x Group deals</p>:null}
                            <a rel="noopener noreferrer" target="_blank" href={props.cart.invoice} className="invoice-text">View invoice</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 ml-xl-auto">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="cart-info-outer inline-cart-xs order-bor">
                                <p className="cart-deal-infoo-text green-color">Purchased On</p>
                                <p className="cart-deal-infoo-text"><span>{props.cart.ordered_on}</span></p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-5">
                            <div className="cart-info-outer inline-cart-xs">
                                <p className="cart-deal-infoo-text custom-color">Total Price</p>
                                <p className="cart-deal-infoo-text font-weight-bold">${props.cart.total}</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-7">
                            <div className="cart-info-outer text-xs-right">
                                <Link to={process.env.PUBLIC_URL+'/cart/purchased/allday/'+props.cart.cart_id} className="grad-on cart-view-btn">View Details</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default purchasedItem;